'use client';

import Slider, { Settings } from 'react-slick';
import { useRef } from 'react';
import { getRecruiterLandingLogos } from '@auth/forms/utils';
import { ImageBj } from '@components/common';
import 'styles/bj_theme/bj_slick_image_gallery.css';

const SlideGrid = ({ items }: { items: { logo: string; name: string }[] }) => (
  <div className="w-ful px-2">
    <div className="grid w-full grid-cols-3 gap-4">
      {items.map((logo) => (
        <div
          key={logo.name}
          className="flex h-15 w-full items-center justify-center rounded-lg border bg-white p-2 shadow-sm"
        >
          <ImageBj
            src={logo.logo}
            alt={logo.name}
            width={120}
            height={60}
            className="max-h-full max-w-full object-contain"
            priority={false}
          />
        </div>
      ))}
    </div>
  </div>
);

const settings: Settings = {
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  arrows: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  className: 'bj-slick-image-gallery flex-col',
};

interface RecruiterLogosCarouselProps {
  className?: string;
}

const RecruiterLogosCarousel = (props: RecruiterLogosCarouselProps) => {
  const { className = '' } = props;
  const logos = getRecruiterLandingLogos().slice(0, 12);
  const slide1 = logos.slice(0, 6);
  const slide2 = logos.slice(6, 12);
  const sliderRef = useRef<Slider | null>(null);

  return (
    <div className={`relative ${className}`}>
      <Slider ref={sliderRef} {...settings}>
        <SlideGrid items={slide1} />
        <SlideGrid items={slide2} />
      </Slider>
    </div>
  );
};

export default RecruiterLogosCarousel;

